/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-east-2",
    "aws_cloud_logic_custom": [
        {
            "name": "typeform",
            "endpoint": "https://ysw22bqokk.execute-api.us-east-2.amazonaws.com/main",
            "region": "us-east-2"
        },
        {
            "name": "usermanagement",
            "endpoint": "https://28hw1xuu2k.execute-api.us-east-2.amazonaws.com/main",
            "region": "us-east-2"
        }
    ],
    "aws_cognito_identity_pool_id": "us-east-2:7669d743-4cea-4869-8aea-924e450c512c",
    "aws_cognito_region": "us-east-2",
    "aws_user_pools_id": "us-east-2_fzDGz6Y1H",
    "aws_user_pools_web_client_id": "rg4dptmhb9ilmpvrope8b0j1u",
    "oauth": {},
    "aws_cognito_username_attributes": [
        "EMAIL"
    ],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_dynamodb_all_tables_region": "us-east-2",
    "aws_dynamodb_table_schemas": [
        {
            "tableName": "companies-main",
            "region": "us-east-2"
        },
        {
            "tableName": "users-main",
            "region": "us-east-2"
        }
    ]
};


export default awsmobile;
